import { Component } from 'react';

export class Timer extends Component {
    state = {
        secondsPassed: 0,
    };

    componentDidMount() {
        this.startTimer();
    }

    startTimer = () => {
        this.timer = setInterval(() => {
            this.tick();
        }, 1000);
    };

    tick = () => {
        this.setState(prevState => {
            return {
                secondsPassed: ++prevState.secondsPassed,
            };
        }, this.props.passTime(this.state.secondsPassed));
    };

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/UI/Components/Timer/index.js